import { FC, useEffect } from 'react';
import { t } from '../../../../utils/helpers';
import { useFormContext } from 'react-hook-form';
import { regExpEmail } from '../../model/const';

export const EmailVerification: FC = () => {
  const {
    trigger,
    setValue,
    register,
    formState: { errors },
  } = useFormContext();

  useEffect(() => {
    trigger('emailValue');
  }, []);

  return (
    <div className="auth-form-item">
      <input
        className={
          errors.emailValue
            ? 'auth-form-item__text auth-form-item__email'
            : 'auth-form-item__text auth-form-item__text--valid auth-form-item__email'
        }
        placeholder={t(`email`)}
        id="emailValue"
        type="email"
        {...register('emailValue', {
          validate: (v) => regExpEmail.test(v),
          required: true,
        })}
        onFocus={() => setValue('phoneValue', '')}
      />
    </div>
  );
};
